import React from 'react';
import { Link } from 'react-router-dom';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="nav-brand">
            <h1 className="logo">BNSN</h1>
            <p className="tagline">Buy, Sell, and Negotiate</p>
          </div>
          <nav className="nav">
            <Link to="/contact" className="nav-link">Contact</Link>
            <Link to="/privacy-policy" className="nav-link">Privacy</Link>
            <Link to="/terms-conditions" className="nav-link">Terms</Link>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Welcome to BNSN</h1>
            <p className="hero-subtitle">Your trusted marketplace for buying and selling</p>
            <p className="hero-description">
              Connect with buyers and sellers in your community. Find great deals, sell your items, 
              and discover amazing products in your local area.
            </p>
            <div className="hero-buttons">
              <button className="btn btn-primary">Start Selling</button>
              <button className="btn btn-secondary">Browse Items</button>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Why Choose BNSN?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">🛒</div>
              <h3>Easy Buying</h3>
              <p>Browse through thousands of items and find exactly what you need</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💰</div>
              <h3>Great Deals</h3>
              <p>Find amazing deals and negotiate prices directly with sellers</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🔒</div>
              <h3>Secure Platform</h3>
              <p>Your data and transactions are protected with our security measures</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">📍</div>
              <h3>Local Focus</h3>
              <p>Connect with people in your area for easy meetups and transactions</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works">
        <div className="container">
          <h2 className="section-title">How It Works</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Sign Up</h3>
              <p>Create your account in minutes</p>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <h3>List or Browse</h3>
              <p>Post your items or browse available listings</p>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <h3>Connect & Deal</h3>
              <p>Message sellers/buyers and complete your transaction</p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>BNSN</h3>
              <p>Your trusted marketplace for buying and selling</p>
            </div>
            <div className="footer-section">
              <h4>Quick Links</h4>
              <ul>
                <li><Link to="/contact">Contact Us</Link></li>
                <li><Link to="/privacy-policy">Privacy Policy</Link></li>
                <li><Link to="/terms-conditions">Terms & Conditions</Link></li>
                <li><Link to="/data-privacy">Data Privacy</Link></li>
              </ul>
            </div>
            <div className="footer-section">
              <h4>Contact Info</h4>
              <p>📞 +91 9741906407</p>
              <p>📧 bnsn.info7@gmail.com</p>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 BNSN. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
